import React from "react";
import { Dialog } from "primereact/dialog";

const DialogComponent = ({
  visible,
  onHide,
  header,
  children,
  className = "",
  style = {},
}) => {
  return (
    <Dialog
      className={`cockpit-dialog ${className}`}
      visible={visible}
      onHide={onHide}
      header={header}
      position="top"
      draggable={false}
      resizable={false}
      closeOnEscape={false}
      modal
      style={{
        width: "50vw",
        maxWidth: "80%",
        height: "70vh", 
        maxHeight: "90%",
        padding: "5px",
        borderRadius: "10px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        ...style,
      }}
    >
      <div className="dialog-content">{children}</div>
    </Dialog>
  );
};

export default DialogComponent;
